import React, { useMemo } from 'react';
import { AgentAvatar } from '@atlaskit/rovo-agent-components';
export function useAgentRefinementTagProps(agent) {
  var props = useMemo(function () {
    if (agent) {
      var _agent$externalConfig;
      return {
        elemBefore: /*#__PURE__*/React.createElement("span", {
          "data-testId": "command-palette-rovo-agent-icon"
        }, /*#__PURE__*/React.createElement(AgentAvatar, {
          agentId: agent.id,
          agentNamedId: (_agent$externalConfig = agent.externalConfigReference) !== null && _agent$externalConfig !== void 0 ? _agent$externalConfig : agent.namedId,
          agentIdentityAccountId: agent.identityAccountId,
          isForgeAgent: agent.creatorType === 'FORGE',
          forgeAgentIconUrl: agent.icon,
          label: agent.name,
          size: "xsmall"
        })),
        appearance: 'rounded'
      };
    } else {
      return undefined;
    }
  }, [agent]);
  return props;
}